module.exports = "<div class=\"frg-navbar-container\">\n  <div class=\"frg-navbar-content\">\n    <nav class=\"frg-navbar\">\n      <ul class=\"brand\">\n        <li><a href=\"#\"><img src=\"/assets/images/freeground-icon.svg\" alt=\"Freeground Icon\"></a></li>\n      </ul>\n    </nav>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jessepinuelas/Development/jesse/freeground.io/src/app/navbar/navbar.component.html
// module id = ../../../../../src/app/navbar/navbar.component.html
// module chunks = main